import { ESeverity } from '#shared';

export const getTimeSeverityFromCrewDutyRanges = (
  ranges: [number, number][],
) => {
  const now = Date.now();
  const curRange = ranges.find(r => r[0] < now && r[1] > now);

  const nextRange = ranges.find(r => r[0] > now);

  if (
    (curRange?.[1] && curRange[1] > now + 8 * 60 * 60 * 1000) ||
    (nextRange?.[0] &&
      nextRange[0] < now + 2 * 60 * 60 * 1000 &&
      nextRange?.[1] &&
      nextRange[1] > now + 8 * 60 * 60 * 1000)
  ) {
    return ESeverity.LOW;
  }
  if (
    (curRange?.[1] && curRange[1] > now + 4 * 60 * 60 * 1000) ||
    (nextRange?.[0] &&
      nextRange[0] < now + 2 * 60 * 60 * 1000 &&
      nextRange?.[1] &&
      nextRange[1] > now + 4 * 60 * 60 * 1000)
  ) {
    return ESeverity.MAJOR;
  }
  if (
    (curRange?.[1] && curRange[1] < now + 4 * 60 * 60 * 1000) ||
    (nextRange?.[0] &&
      nextRange?.[0] < now + 2 * 60 * 60 * 1000 &&
      nextRange?.[1] &&
      nextRange[1] > now + 2 * 60 * 60 * 1000)
  ) {
    return ESeverity.CRITICAL;
  }

  return ESeverity.NA;
};
